// extracted by mini-css-extract-plugin
export default {"title":"unexpectedError_title__kj8TR"};